(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('gvp-glass-header')) {
    customElements.define(
      'gvp-glass-header',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;

          this.controller = new AbortController();
          const options = { signal: this.controller.signal };

          this.dialog = this.querySelector('.gvp-dialog');
          this.openButton = this.querySelector('[data-gvp-open]');
          this.closeButton = this.querySelector('[data-gvp-close]');
          this.spacer = document.getElementById(this.dataset.spacerId);
          this.overlayHome = this.dataset.overlay === 'true';
          this.threshold = Number(this.dataset.scrollThreshold) || 0;

          if (!this.dialog || !this.openButton || !this.closeButton) {
            this.controller.abort();
            this.controller = null;
            return;
          }

          this.updateScrollState = () => {
            const scrolled = window.scrollY > this.threshold;

            this.classList.toggle('has-scroll', window.scrollY > 0);
            this.classList.toggle('is-scrolled', scrolled);
            this.classList.toggle(
              'is-transparent',
              this.overlayHome && !scrolled
            );
          };

          this.scheduleScrollUpdate = () => {
            if (this.scrollFrame) return;

            this.scrollFrame = requestAnimationFrame(() => {
              this.scrollFrame = null;
              this.updateScrollState();
            });
          };

          window.addEventListener('scroll', this.scheduleScrollUpdate, {
            passive: true,
            signal: this.controller.signal
          });

          window.addEventListener('pageshow', this.updateScrollState, options);

          this.updateScrollState();

          const updateSpacer = () => {
            if (!this.spacer) return;

            const height = this.overlayHome
              ? 0
              : Math.ceil(this.getBoundingClientRect().height);

            const value = `${height}px`;

            if (this.spacer.style.height !== value) {
              this.spacer.style.height = value;
            }
          };

          this.headerObserver = new ResizeObserver(updateSpacer);
          this.headerObserver.observe(this);
          updateSpacer();

          this.openButton.addEventListener('click', () => {
            if (this.dialog.open) return;

            this.dialog.showModal();
            this.openButton.setAttribute('aria-expanded', 'true');

            this.previousOverflow =
              document.documentElement.style.overflow;

            document.documentElement.style.overflow = 'hidden';
            this.scrollLocked = true;
          }, options);

          this.closeButton.addEventListener('click', () => {
            this.dialog.close();
          }, options);

          this.dialog.addEventListener('close', () => {
            this.openButton.setAttribute('aria-expanded', 'false');
            this.unlockScroll();
          }, options);

          this.dialog.addEventListener('click', (event) => {
            const bounds = this.dialog.getBoundingClientRect();

            const outside =
              event.clientX < bounds.left ||
              event.clientX > bounds.right ||
              event.clientY < bounds.top ||
              event.clientY > bounds.bottom;

            if (event.target === this.dialog && outside) {
              this.dialog.close();
              return;
            }

            if (
              event.target instanceof Element &&
              event.target.closest('a[href]')
            ) {
              this.dialog.close();
            }
          }, options);

          const pauseButton = this.querySelector('[data-gvp-pause]');
          const promo = this.querySelector('.gvp-promo');

          if (pauseButton && promo) {
            pauseButton.addEventListener('click', () => {
              const paused = promo.toggleAttribute('data-paused');

              pauseButton.setAttribute('aria-pressed', String(paused));
              pauseButton.setAttribute(
                'aria-label',
                paused
                  ? 'Reprendre le défilement'
                  : 'Mettre le défilement en pause'
              );

              pauseButton.querySelector(
                '[data-gvp-pause-icon]'
              ).textContent = paused ? '▶' : 'Ⅱ';
            }, options);
          }

          const group = this.querySelector('.gvp-track-group');
          const track = this.querySelector('.gvp-track');

          if (group && track) {
            this.trackObserver = new ResizeObserver(() => {
              const width = group.getBoundingClientRect().width;

              if (width > 0) {
                track.style.setProperty('--gvp-travel', `-${width}px`);
              }
            });

            this.trackObserver.observe(group);
          }
        }

        unlockScroll() {
          if (!this.scrollLocked) return;

          document.documentElement.style.overflow =
            this.previousOverflow;

          this.scrollLocked = false;
        }

        disconnectedCallback() {
          if (this.dialog && this.dialog.open) {
            this.dialog.close();
          }

          this.unlockScroll();
          this.controller?.abort();
          this.headerObserver?.disconnect();
          this.trackObserver?.disconnect();

          if (this.scrollFrame) {
            cancelAnimationFrame(this.scrollFrame);
          }

          this.scrollFrame = null;
          this.controller = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
